<template>
  <div id="app">
    <main-header v-if="!isMobile()"></main-header>
    <header-mobile v-if="isMobile()"></header-mobile>
    <div class="maincontent" id="maincontent">
      <router-view></router-view><!--Noi dung chinh nam day-->
    </div>
    <main-footer v-if="!isMobile()"></main-footer>
    <footer-mobile v-if="isMobile()"></footer-mobile>
  </div>
</template>

<script>
import MainHeader from '@/components/Header'
import MainFooter from '@/components/Footer'
import HeaderMobile from '@/components/HeaderMobile'
import FooterMobile from '@/components/FooterMobile'
import {mixinDetictingMobile} from './mixinDetectMobile'

export default {
  name: 'App',
  mixins: [mixinDetictingMobile],
  components: {
    MainHeader,
    MainFooter,
    HeaderMobile,
    FooterMobile
  },
  created () {
    if(this.checkIsMobile()){
      $("header").css("cssText", "width: 100%");
      $(".maincontent").css("cssText", "width: 100%");
    }


    //Luu log truy cap website/wapsite
    var d = new Date();
    var requestId = d.getTime();
    var userAgent = navigator.userAgent;
    var cpId = this.$route.query.cpId;
    var serviceId = this.$route.query.serviceId;
    var referrer = document.referrer;
    var ip = null;
    var is3G = null;
    var urlAccess = window.location.href;
    let dataSave = "";

    //Get IP address
    axios.get(api.getInfoAccessDevice)
      .then(response => {
        ip = response.data.ip;
        return axios.get(api.checkTelco);
      })
      .then(response => {
        if(response.data === "#"){
          //Khong phai su dung 3G mobifone, co the la wifi, co the la mang 3G cua viettel, vinaphone
          is3G = 2;
        } else {
          //Su dung 3G mobifone
          is3G = 1;
        }
        //Save thong tin log truy cap
        //debugger
        dataSave = {
          "userAgent": userAgent,
          "ipAddress": ip,
          "cpId": cpId,
          "serviceId": serviceId,
          "requestId": requestId,
          "type": 1, //1 la thong tin request; 2 la thong tin response
          "msisdn": !this.$session.exists() ? null : this.$session.get('userInfo').user,
          "referral": referrer,
          "is3G": is3G,
          "urlAccess": urlAccess
        }
        this.$cookies.set("deviceAccess", dataSave, "60s");
        //console.log(dataSave);
        return axios.post(api.saveLog, dataSave);
      })
      .then(response => {
        console.log("SaveLong Click: ", response.data.errorMessage);
        /*if(response.data.errorMessage === "Success"){
          if(this.$cookies.isKey("deviceAccess") === false){

          }
        }*/
      })
      .catch(e => {
        console.log(e);
      })
  },
  data () {
    return {
      authenticated: false,
      acountinfo: {
        username: '',
        password: ''
      }
    }
  },
  mounted () {
    // if(!this.authenticated){
    //   this.$router.replace({name: 'Login'});
    // }
    // console.log('mounted');

    /*if (!this.$session.get('username')) {
      this.$router.push('/login')
    }*/
  },
  methods: {
  }
}
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    /*width: 1260px;*/
    margin: 0 auto;
  }
  header{
    width: 1260px;
    margin: 0 auto;
    margin-bottom: 2rem;
  }
  .maincontent{
    width: 1260px;
    margin: 0 auto;
  }
  @media screen and (max-width: 720px){
    header{
      width: 100%;
      margin: 0 auto;
    }
    .maincontent{
      width: 100%;
      margin: 0 auto;
    }
  }
  footer{
    margin-top: 30px;
    background-color: #f0f0f0;
    min-height: 150px;
  }
  .footer-1{
    padding: 1rem 6rem;
  }
  .footer-2{
    line-height: 60px;
    padding: 0 6rem;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue